import { ReturnRequestDto, ShopDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import ExchangeCreditSummary from "@/components/articles-lists/exchange-credit-summary";
import { NewProductForExchangeCreditList } from "../../../refund/page";

export function ListExchangeCreditArticle(props: {
  returnRequest: ReturnRequestDto;
  shop: ShopDto;
}) {
  const t = useTranslation();
  const newOrder = props.returnRequest.line_items
    .filter((li) => li.resolution === "exchange-credit")?.[0]
    ?.merchant_informations.filter((mi) => mi.status === "ok")?.[0]?.result;

  if (!props.returnRequest.exchange.newProductForExchangeCredit.length) {
    return;
  }

  return (
    <div>
      <h2 className="text-lg font-medium text-gray-900 mt-6 mb-2">
        {t("returnDetail.newOrderExchangeCredit")}
        {newOrder && (
          <a
            className="ml-0.5 text-purple-600 hover:text-purple-700"
            href={`https://${props.shop.shopifyUrl}/admin/orders/${newOrder.newOrderId}`}
            target="_blank"
            rel="noreferrer"
          >
            {newOrder.newOrderName}
          </a>
        )}
      </h2>
      <div className="prose max-w-none">
        <NewProductForExchangeCreditList
          items={props.returnRequest.exchange.newProductForExchangeCredit}
          currency={props.returnRequest.currency.customerCurrency}
        />
      </div>
      <ExchangeCreditSummary returnRequest={props.returnRequest} />
    </div>
  );
}
